import { ApolloClient, gql } from '@apollo/client/core';
import { Query } from '../../generated/graphql';
import * as Order from './Order';
import { VENUE_FIELDS } from '../Venue/Api';
import { EVENT_FIELDS_MINIMAL } from '../Event/Api';

const TICKET_FIELDS = gql`
  fragment TicketFields on Ticket {
    id
    token
    firstName
    lastName
    name
    seat
    table
    ticketType
    checkedInBy {
      name
      email
    }
    price
    pdfUrl
    pdfPreviewUrl
  }
`;

const ORDER_FIELDS = gql`
  fragment OrderFields on Order {
    id
    ticketLayout
    code
    customer {
      email
      firstName
      lastName
    }
    event {
      ...EventFieldsMinimal
      announceDetail {
        id
        promoter
        support
      }
    }
    venue {
      ...VenueFields
    }
    tickets {
      ...TicketFields
    }
  }
  ${TICKET_FIELDS}
  ${VENUE_FIELDS}
  ${EVENT_FIELDS_MINIMAL}
`;

const ORDER_QUERY = gql`
  query Order($id: Int!) {
    app {
      order(id: $id) {
        ...OrderFields
      }
    }
  }
  ${ORDER_FIELDS}
`;

export const fetchOrder = async (client: ApolloClient<Query>, id: number): Promise<Order.Order> => {
  const { data } = await client.query({
    query: ORDER_QUERY,
    variables: {
      id,
    },
  });

  return Order.fromGQL(data.app.order);
};
